import { redirectToPostApplication } from '@servicetitan/financing-utils-shared';
import { ExternalApplicationStore } from './ExternalApplicationStore';

// Re-export the utility function for backwards compatibility
export { redirectToPostApplication };

/**
 * Custom hook that provides a function to redirect to the post-application page.
 * Automatically retrieves the loan ID from the ExternalApplicationStore.
 *
 * @returns A function that redirects to the post-application page
 */
export const useRedirectToPostApplication = () => {
    const { externalApplicationData } = ExternalApplicationStore.useStore();

    return () => {
        const loanId = (externalApplicationData?.loanId ?? '') || '0';
        redirectToPostApplication(loanId);
    };
};
